import React from 'react'
import { ChatBubbleLeftRightIcon, SignalIcon } from '@heroicons/react/24/solid'
import { useCoachChat } from './CoachChatContext'
import { useTranslation } from '~/hooks/useTranslation'
import { getStatusBannerStyles } from './coachDashboardStyles'

const CoachChatStatusBanner = ({ currentAvailability }) => {
  const { getDarkModeClasses } = useCoachChat()
  const { t } = useTranslation('coach_chat')

  const isLive =
    currentAvailability === 'text_only' || currentAvailability === 'audio_video'

  const styles = getStatusBannerStyles(currentAvailability, getDarkModeClasses)

  const StatusIcon =
    currentAvailability === 'text_only' ? ChatBubbleLeftRightIcon : SignalIcon

  const statusValue = isLive
    ? currentAvailability === 'text_only'
      ? t(
          'coach_settings.availability_text_only',
          'Live — Accepting Text Chats',
        )
      : t(
          'coach_settings.availability_audio_video',
          'Live — Accepting Text/Audio/Video Chats',
        )
    : t(
        'coach_settings.availability_away',
        'Inactive – Not Available (Default)',
      )

  return (
    <div
      className={`flex items-start gap-3 rounded-[10px] p-4 ${styles.container}`}
    >
      <StatusIcon
        className={`mt-0.5 h-5 w-5 flex-shrink-0 ${styles.value}`}
        aria-hidden="true"
      />
      <div className="min-w-0 flex-1">
        <p className={`font-['Roboto'] text-xs font-normal ${styles.label}`}>
          {t('coach_status_banner.current_status', 'Current Status')}
        </p>
        <p
          className={`font-['Roboto'] text-base font-semibold ${styles.value}`}
        >
          {statusValue}
        </p>
      </div>
    </div>
  )
}

export default CoachChatStatusBanner
